import {
  View,
  useTheme,
  Text,
  Heading,
  useAuthenticator,
  Button,
  createTheme,
  defaultDarkModeOverride
} from "@aws-amplify/ui-react";

export const components = {
  Header() {
    const { tokens } = useTheme();
    // https://images.squarespace-cdn.com/content/63121bdc04e1e907fe9ed158/a1b80031-f98d-45a6-b078-75ac671238ed/WaterDrop.png?content-type=image%2Fpng
    return (
      <View style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        paddingBottom: '0px',
        fontSize: '3em',
        marginBottom: '30px',
        marginTop: '30px',
      }} padding={tokens.space.large}>
        SewerTycoon
      </View>
    );
  },

  Footer() {
    const { tokens } = useTheme();

    return (
      <View textAlign="center" padding={tokens.space.large}>
        <Text color={tokens.colors.neutral[80]}>
          DWL@UM
        </Text>
      </View>
    );
  },

  SignIn: {
    Header() {
      const { tokens } = useTheme();

      return (
        <Heading
          paddingTop={tokens.space.large}
          level={3}
          textAlign="center"
        >
          Sign in to your account
        </Heading>
      );
    },
    Footer() {
      const { toForgotPassword } = useAuthenticator();

      return (
        <View textAlign="center">
          <Button
            fontWeight="normal"
            onClick={toForgotPassword}
            size="small"
            variation="link"
          >
            Reset Password
          </Button>
        </View>
      );
    },
  },

  SignUp: {
    Header() {
      const { tokens } = useTheme();

      return (
        <Heading
          paddingTop={tokens.space.large}
          level={3}
          textAlign="center"
        >
          Create a new account
        </Heading>
      );
    },
    Footer() {
      const { toSignIn } = useAuthenticator();

      return (
        <View textAlign="center">
          <Button
            fontWeight="normal"
            onClick={toSignIn}
            size="small"
            variation="link"
          >
            Back to Sign In
          </Button>
        </View>
      );
    },
  },
  ConfirmSignUp: {
    Header() {
      const { tokens } = useTheme();
      return (
        <Heading
          padding={`${tokens.space.xl} 0 0 ${tokens.space.xl}`}
          level={3}
        >
          Enter Information:
        </Heading>
      );
    },
  },
  SetupTotp: {
    Header() {
      const { tokens } = useTheme();
      return (
        <Heading
          padding={`${tokens.space.xl} 0 0 ${tokens.space.xl}`}
          level={3}
        >
          Enter Information:
        </Heading>
      );
    },
  },
  ConfirmSignIn: {
    Header() {
      const { tokens } = useTheme();
      return (
        <Heading
          padding={`${tokens.space.xl} 0 0 ${tokens.space.xl}`}
          level={3}
        >
          Enter Information:
        </Heading>
      );
    },
    Footer() {
      return <Text>Footer Information</Text>;
    },
  },
  ForgotPassword: {
    Header() {
      const { tokens } = useTheme();
      return (
        <Heading
          padding={`${tokens.space.xl} 0 0 ${tokens.space.xl}`}
          level={3}
        >
          Enter Information:
        </Heading>
      );
    },
  },
  ConfirmResetPassword: {
    Header() {
      const { tokens } = useTheme();
      return (
        <Heading
          padding={`${tokens.space.xl} 0 0 ${tokens.space.xl}`}
          level={3}
        >
          Enter Information:
        </Heading>
      );
    },
  },
  SelectMfaType: {
    Header() {
      return <Heading level={3}>Select Desired MFA Type</Heading>;
    },
  },
  SetupEmail: {
    Header() {
      return <Heading level={3}>Email MFA Setup</Heading>;
    },
  },
};

const theme = createTheme({
  name: 'base-theme',
  overrides: [defaultDarkModeOverride],
});

export const moddedTheme = createTheme({
    name: 'other-brand-theme',
    tokens: {
      components: {
        authenticator: {
          router: {
            backgroundColor: { value: 'rgba(255, 255, 255, 0)' },
            borderWidth: { value: '0px' },
            borderStyle: { value: 'solid' },
            borderColor: { value: 'rgba(255, 255, 255, 0.70)' },
          },
        },
      },

    },
  },
  theme
)